import { isNumber } from "lodash";

const isInteger = (value) => isNumber(value) && value % 1 === 0;

export { isInteger };
